// extracted by mini-css-extract-plugin
export var content = "_2w-3";
export var contentWrapper = "_2w-2";
export var fullWidthButton = "_2w-4";
export var heroImage = "_2w-6";
export var logo = "_2w-1";
export var logoContainer = "_2w-0";
export var panel = "_2w-5";